import Swiper from "swiper"

import { Autoplay } from "swiper/modules"

import "swiper/css"

function marquee(el: HTMLElement) {
  const marqueeEl = el.querySelector<HTMLDivElement>(".swiper.marquee-main")
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches

  if (!marqueeEl) {
    return
  }

  const marquee = new Swiper(marqueeEl, {
    modules: [Autoplay],
    loop: true,
    speed: reduceMotion ? 0 : 6000,
    slidesPerView: "auto",
    spaceBetween: 60,
    allowTouchMove: reduceMotion ? true : false,
    grabCursor: reduceMotion ? true : false,
    resizeObserver: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    breakpoints: {
      1200: {
        spaceBetween: 84,
      },
    },
    on: {
      init: swiper => {
        ensureLoopConditions(swiper)
      },
      resize: swiper => {
        ensureLoopConditions(swiper)
      },
    },
  })

  if (reduceMotion) {
    marquee.autoplay.stop()
  }

  // Ensure there are enough slides to loop; duplicates slides if needed
  function ensureLoopConditions(swiper: Swiper) {
    if (!swiper) {
      return
    }

    // check if the total width of slides meets the minimun width required to loop
    const widthOfSlides = calculateSlideWidth(swiper)
    const minWidth = swiper.width * 2
    if (widthOfSlides > minWidth) return

    // calculate the total amount of duplicate sets required to meet the minimum
    const duplicatesRequired = Math.ceil(minWidth / widthOfSlides) - 1

    if (duplicatesRequired > 0) {
      let originalSlides = swiper.wrapperEl.innerHTML
      swiper.wrapperEl.innerHTML =
        originalSlides + duplicateSlides(swiper).repeat(duplicatesRequired)
      swiper.update()
    }
  }

  function calculateSlideWidth(swiper: Swiper) {
    const margin =
      typeof swiper.params.spaceBetween === "number"
        ? swiper.params.spaceBetween
        : 0
    let widthOfSlides = 0
    swiper.slides.forEach(slide => {
      const slideWidth = slide.offsetWidth + margin
      widthOfSlides += slideWidth
    })
    return widthOfSlides
  }

  function duplicateSlides(swiper: Swiper) {
    let duplicateSlides = ""
    for (let i = 0; i < swiper.slides.length; i++) {
      duplicateSlides += `<li class="swiper-slide swiper-slide-duplicate" aria-hidden="true" data-swiper-slide-index="${i}">${swiper.slides[i].innerHTML}</li>`
    }
    return duplicateSlides
  }
}

export default marquee
